import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { ShortcutItem } from "@repo/core/components/core/Shortcuts/types";
import useAuthStore from "@repo/core/stores/auth";
import { useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { newApInstance } from "@repo/core/services/instances/new-api";
import { ProposalsResource } from "@repo/core/services/resources/proposals";
import { usePreProposal } from "@repo/core/screens/PreProposal/hooks/usePreProposal";
import { useResendCodeConfig } from "@repo/core/hooks/useResendCodeConfig";

const newApiProposalsResource = new ProposalsResource(newApInstance);

export const useHomeController = () => {
  const { user } = useAuthStore();
  const { push } = useNavigation();
  const { startPreProposal } = usePreProposal();
  const { fetchResendConfig } = useResendCodeConfig();

  const { isTablet, isMobile, isWeb } = useDeviceType();

  const { data: dailySummaryData } = useQuery({
    queryKey: ["findDailySummary"],
    queryFn: () => newApiProposalsResource.getDailySummary(),
    staleTime: 1000 * 60 // 1 minute - prevents multiple requests on rapid mount/unmount cycles (e.g. navigation redirects)
  });

  useEffect(() => {
    fetchResendConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerHeight = useMemo(() => {
    if (isTablet) {
      return 298;
    }

    if (isMobile) {
      return 298;
    }

    return 242;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTablet, isMobile]);

  const headerPaddingTop = useMemo(() => {
    if (isTablet) {
      return 18;
    }

    if (isMobile) {
      return 4;
    }

    return 24;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, isTablet]);

  const gradientColors = ["#001A14", "#08AA89"];

  const SHORTCUTS: ShortcutItem[] = [
    {
      onPress: () => {
        startPreProposal();
      },
      icon: "file-circle-check",
      label: "Nova Proposta",
      type: "primary"
    }
    /*   {
      onPress: () => {
        startNewTransactionFlow(TransactionFlowType.PURCHASE);
      },
      icon: "credit-card",
      label: `Compra \n no Crédito`,
      type: "primary"
    }, */
    /*  {
      onPress: () => {
        startNewTransactionFlow(TransactionFlowType.FIDELITY_SCORE);
      },
      icon: "star",
      label: "Pontuar Fidelidade",
      type: "primary"
    }, */
    /*  {
      onPress: () => {
        push(ROUTES.support);
      },
      icon: "circle-question",
      label: "Suporte",
      type: "primary"
    } */
  ];

  /*  const SUMMARIES = [
    {
      amount: totalCreditSalesValue || 0,
      chartColor: "#3FEDC7",
      label: "Compras"
    },
    {
      amount: totalWithdrawalsValue || 0,
      chartColor: "#A5D447",
      label: "Saques"
    }
  ]; */

  const proposalsSummary = [
    {
      amount: dailySummaryData?.data?.approved || 0,
      chartColor: "#08AA89",
      label: "Aprovadas"
    },
    {
      amount: dailySummaryData?.data?.rejected || 0,
      chartColor: "#EF4444",
      label: "Reprovadas"
    }
  ];

  const handleGoToAllTransactions = () => {
    push(ROUTES.transactions);
  };

  const handleGoToProfile = () => {
    push(ROUTES.profile);
  };

  return {
    user,
    gradientColors,
    proposalsSummary,
    headerHeight,
    handleGoToProfile,
    SHORTCUTS,
    handleGoToAllTransactions,
    isMobile,
    headerPaddingTop,
    isWeb,
    isTablet
  };
};
